module.exports = __webpack_public_path__ + "img/clickup.ded2a85c.png";